<ion-content>
  <ion-scroll zooming="true" direction="xy" style="height:500px">
    <div class="allpageview">
      <div class="race-info-modal modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button (click)="dismiss()" type="link" class="close">
              <span class="icon icon-close"></span>
            </button> <br>
            <div style="width: 100%;" class="description mt-3" *ngIf="value.featured_image?.medium">
              <img style="width: 100%;" src="{{value.featured_image.medium}}" alt="...">
            </div>
            <div style="width: 100%;" class="description mt-3" *ngIf="!value.featured_image?.medium && value.thumbnail_images">
              <img style="width: 100%;" src="{{value.thumbnail_images.medium.url}}" alt="...">
            </div>

            <!-- <div class="description" *ngIf="!value.featured_image.medium">
              <img src="{{value.thumbnail_images.medium.url}}" alt="...">
            </div> -->
          </div>
          <div class="modal-body">
            <h4 class="text-center text-black">{{value.title}}</h4>
            <div class="runner-comments">
              <div id="contentValue" class="text-black">
                {{value.content}}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </ion-scroll>

</ion-content>